export default __webpack_public_path__ + "static/media/arrow-top.3f2f4688.svg";